import React from 'react';

const Header=()=>{
    return(
        <div className="ui blue three item inverted menu" >
            <h2 >Contact Manager</h2>
            
        </div>
        

    );
}
export default Header;
